import { Button } from "@globalgiving/components"
import { FC } from "react"
import { AccessDeniedIllustrationIcon, BirdIcon } from "~/icons/png-icons"

export const ErrorFallback: FC<{ className?: string }> = ({ className = "" }) => {
  const handleRetry = () => {
    window.location.reload()
  }

  return (
    <div className={`flex flex-col items-center justify-center bg-secondary-navy-darker p-6 ${className}`}>
      <img alt="Access Denied icon" className="mb-5" src={AccessDeniedIllustrationIcon} />
      <h1 className="headline-jumbo mb-3 text-white">Oops!</h1>
      <div className="relative mb-10 w-full max-w-[420px]">
        <div className="h-[5px] w-full bg-primary-blue" />
        <img alt="Bird icon" className="absolute -bottom-8 left-20 h-16 w-14" src={BirdIcon} />
      </div>
      <p className="body-large mb-4 font-bold text-primary-orange-light">
        Something went wrong when loading this page.
      </p>
      <div className="body-large mb-4 flex flex-col items-center text-center font-regular text-white">
        <p>
          Please try again. If the issue persists, contact our support team <br />
          at <b>help@globalgiving.org</b>
        </p>
      </div>
      <Button onClick={handleRetry}>Try Again</Button>
    </div>
  )
}
